import statusList from "../data/statusList.json";

/**
 * Canonical ordered list of sale/work-order statuses.
 * Sourced from data/statusList.json so the API and UI stay in sync.
 */
export const SALE_STATUSES = statusList.map((s) => s.status);

/**
 * Maps a status to a Badge tone (defined in components/ui/Badge.js).
 * Used everywhere a sale status is rendered as a pill / chip.
 */
export const STATUS_TONE = {
    Processed: "neutral",
    "Pending Parts": "warning",
    "Pending Paint": "warning",
    Prep: "info",
    "Making Door": "info",
    Ship: "success",
    "Ready For Installation": "success",
    "Ready For Pick Up": "success",
    Completed: "neutral",
};

/**
 * Maps a status to a Tailwind border-color class. Used by card layouts
 * (e.g. WorkOrders) to indicate status with a colored side border.
 */
export const STATUS_BORDER = {
    Processed: "border-l-ink-400",
    "Pending Parts": "border-l-warning-400",
    "Pending Paint": "border-l-warning-500",
    Prep: "border-l-info-500",
    "Making Door": "border-l-info-500",
    Ship: "border-l-success-500",
    "Ready For Installation": "border-l-success-500",
    "Ready For Pick Up": "border-l-success-500",
    Completed: "border-l-ink-300",
};

export const getStatusTone = (status) => STATUS_TONE[status] || "neutral";
export const getStatusBorder = (status) => STATUS_BORDER[status] || "border-l-ink-300";

/**
 * Color tone for filter chips per status. Translates to the chip-tone
 * keys recognised by DataTable's FilterChipStrip (see components/ui/DataTable.js).
 */
export const STATUS_CHIP_TONE = {
    Processed: "gray",
    "Pending Parts": "yellow",
    Prep: "darkBlue",
    Ship: "darkGreen",
    "Pending Paint": "orange",
    "Making Door": "blue",
    "Ready For Installation": "green",
    "Ready For Pick Up": "green",
    Completed: "lightGray",
};

export const getStatusChipTone = (status) => STATUS_CHIP_TONE[status] || "neutral";
